import { render, staticRenderFns } from "./artist-card.vue?vue&type=template&id=16be688c"
import script from "./artist-card.vue?vue&type=script&lang=js"
export * from "./artist-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports